{
  "list": {
    "title": "스마트 문구",
    "backToDashboard": "대시보드",
    "newButton": "새 문구",
    "import": "가져오기",
    "export": "내보내기",
    "searchPlaceholder": "키 또는 확장 텍스트로 검색...",
    "filterAllCategories": "모든 카테고리",
    "header": "문구 ({{count}})",
    "loading": "문구를 불러오는 중...",
    "empty": "문구를 찾을 수 없습니다. 첫 스마트 문구를 만들어 보세요.",
    "authoredBy": "작성자: {{name}}",
    "tooltips": {
      "preview": "미리보기",
      "edit": "편집",
      "delete": "삭제"
    },
    "confirmDelete": "확인",
    "cancelDelete": "취소",
    "previewLabel": "미리보기:",
    "closePreview": "미리보기 닫기",
    "toast": {
      "deleted": "문구가 삭제되었습니다",
      "importComingSoon": "가져오기 기능 곧 제공 예정",
      "exportComingSoon": "내보내기 기능 곧 제공 예정"
    }
  },
  "form": {
    "editTitle": "스마트 문구 편집",
    "createTitle": "새 스마트 문구",
    "fields": {
      "key": "키",
      "category": "카테고리",
      "expansionText": "확장 텍스트"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "\".\" 으로 시작해야 합니다",
    "categoryUncategorized": "미분류",
    "expansionPlaceholder": "단축키를 대체할 텍스트를 입력하세요...",
    "cancel": "취소",
    "create": "문구 만들기",
    "update": "문구 업데이트",
    "toast": {
      "created": "문구가 생성되었습니다",
      "updated": "문구가 업데이트되었습니다",
      "saveFailed": "문구 저장 실패",
      "keyMustStartWithDot": "키는 \".\" 으로 시작해야 합니다",
      "keyTooShort": "키는 최소 2자 이상이어야 합니다",
      "expansionRequired": "확장 텍스트는 필수입니다"
    }
  },
  "category": {
    "general": "일반",
    "physicalExam": "신체 검사",
    "reviewOfSystems": "계통 문진",
    "assessment": "평가",
    "plan": "계획",
    "instructions": "지시 사항",
    "medications": "약물",
    "history": "병력"
  }
}
